function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.3747 0.000297546C10.6307 0.000297546 12.6447 1.4333 13.3837 3.5673C13.5197 3.9583 13.3117 4.3853 12.9197 4.5213C12.5287 4.6583 12.1017 4.4493 11.9657 4.0573C11.4367 2.5283 9.9917 1.5003 8.3717 1.5003H8.3577C6.2657 1.5003 4.5617 3.1943 4.5527 5.2843L4.552 6.6263L12.184 6.627C14.688 6.627 16.726 8.665 16.726 11.17V15.458C16.726 17.963 14.688 20.001 12.184 20.001H4.542C2.037 20.001 0 17.963 0 15.458V11.17C0 9.18661 1.277 7.49598 3.05221 6.87791L3.0527 5.3013C3.0657 2.3633 5.4417 0.000297546 8.3547 0.000297546H8.3747ZM12.184 8.127H4.542C2.864 8.127 1.5 9.492 1.5 11.17V15.458C1.5 17.136 2.864 18.501 4.542 18.501H12.184C13.861 18.501 15.226 17.136 15.226 15.458V11.17C15.226 9.492 13.861 8.127 12.184 8.127ZM8.3633 11.4528C8.7773 11.4528 9.1133 11.7888 9.1133 12.2028V14.4248C9.1133 14.8388 8.7773 15.1748 8.3633 15.1748C7.9493 15.1748 7.6133 14.8388 7.6133 14.4248V12.2028C7.6133 11.7888 7.9493 11.4528 8.3633 11.4528Z",
  fill: "#2C82F6"
});

var SvgLockLogo = function SvgLockLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLockLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Lock-logo.dc789c9b.svg";
export { ForwardRef as ReactComponent };